export default function (Component) {
Component.options.__docs = "<p>You can use <code>borderless</code> on <code>FdTable</code> in order to disable the outer table border.</p>\n"
}